import { TranslateService } from '@ngx-translate/core';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpHelpersService } from '../http-helpers/http-helpers.service';
import { HttpClient } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Response } from 'src/app/models/response.model';
import { ToastController, Platform, ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { PushNotifications } from '@capacitor/push-notifications';

import { UtilsService } from '../utils/utils.service';


@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  url: string;
  @Output() reloadPendings = new EventEmitter<any>();
  @Output() reloadAC = new EventEmitter<any>();
  @Output() reloadMessages = new EventEmitter<any>();
  @Output() reloadRequests = new EventEmitter<any>();

  public pushObjectSubscripcion: Subscription;
  token = "";

  constructor(
    private httpHelpers: HttpHelpersService,
    private http: HttpClient,
    public toastCtlr: ToastController,
    private router: Router,
    private platform: Platform,
    private utils: UtilsService,
    private modalCtrl: ModalController,
    private translate : TranslateService
  ) {
    this.url = this.httpHelpers.getUrl();
  }

  initializeNotifications({ uuid, os, model }): Promise<any> {
    return new Promise(async (res, rej) => {
      try {
        let permStatus = await PushNotifications.checkPermissions();
        console.log('permStatus', permStatus)
        if (permStatus.receive === 'prompt' || permStatus.receive === 'prompt-with-rationale') {
          permStatus = await PushNotifications.requestPermissions();
        }

        if (permStatus.receive !== 'granted') {
          this.utils.showMessage(this.translate.instant('notifications.Acceso para enviar notificaciones negado'));
          this.utils.saveInStorage('pushHasPermission', false);
          rej();
        } else {

          await PushNotifications.register().then((data) => { });
          const type = this.platform.is("android") ? "fcm" : "apn";
          if (this.token !== '') {
            const token = this.token;
            this.utils.saveInStorage("pushHasPermission", true);
            this.utils.saveInStorage("androidNotificationPermission", true);
            this.utils.saveInStorage("totalNotifications", 0);
            res({ token });
          } else {
            await PushNotifications.addListener("registration", async (data) => {
              console.log('token', data)
              this.token = await data.value;
              const token = this.token;
              this.saveToken({ uuid, os, model, token, type }).subscribe(
                async ({ operation, error }) => {
                  if (error) {
                    this.utils.showMessage(operation);
                    rej();
                  } else {
                    this.utils.saveInStorage("pushHasPermission", true);
                    this.utils.saveInStorage("androidNotificationPermission", true);
                    this.utils.saveInStorage("totalNotifications", 0);
                    res({ token });
                  }
                }
              );
            });
          }
        }


      } catch {
        this.utils.showMessage(this.translate.instant('notifications.Error activando notificaciones'));
        this.utils.saveInStorage('pushHasPermission', false);
        rej();
      }
    })
  }

  saveToken(deviceInfo): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader()
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.post<Response>(`${this.url}/auth/dispositivos`, deviceInfo,
      httpOptions).
      pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('notifications.registrar dispositivo para envío de notificaciones')))
      );
  }

  activateNotifications(deviceInfo): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader()
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.put<Response>(`${this.url}/auth/dispositivos/${deviceInfo.uuid}/activar`, deviceInfo,
      httpOptions).
      pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('notifications.activar notificaciones')))
      );
  }

  deactivateNotifications(deviceInfo): Observable<any> {
    const httpOptions = {
      ...this.httpHelpers.getHeader()
    }
    this.url = this.httpHelpers.getUrl();
    return this.http.put<Response>(`${this.url}/auth/dispositivos/${deviceInfo.uuid}/desactivar`, deviceInfo,
      httpOptions).
      pipe(map((data) => {
        return data
      }),
        catchError(this.httpHelpers.errorHandler(this.translate.instant('notifications.desactivar notificaciones')))
      );
  }

  async manageNotification(notification) {
    const notificationData = {
      title: this.platform.is("android") ? notification["pinpoint.notification.title"] : notification.aps.alert.title,
      message: this.platform.is("android") ? notification["pinpoint.notification.body"] : notification.aps.alert.body,
      data: this.platform.is("android") ? JSON.parse(notification["pinpoint.jsonBody"]) : notification.data.jsonBody,
    };

    if (notificationData.message.includes('eliminada')) {
      notificationData.data['accion'] = 'eliminar';
    }
    if (notificationData.message.includes('Nueva actualización')) {
      notificationData.data['accion'] = 'chat';
    }
    const solicitud_id = notificationData.data.solicitud_id;
    let noti = notificationData.data;
    await this.utils.saveInStorage("notification", noti);
    // if (!notification["pinpoint.openApp"] || (this.router.url.includes("/requirement-follow-up") &&
    //   parseInt(window.history.state.reqId) === parseInt(solicitud_id) &&
    //   !notificationData.data.accion)) {
    //   const isModalOpen = await this.modalCtrl.getTop();
    //   console.log('isModalOpen', isModalOpen);

    //   if (isModalOpen) {
    //     this.navigateToRouteForNotification(notificationData.data);
    //   } else {
    //     this.showNotificationMsgForeground(notificationData);
    //   }
    // } else {
    //   if (this.router.url.includes("/properties")) this.reloadRequests.emit();
    //   this.showNotificationMsgForeground(notificationData);
    // }

    if (notification.isBackround) {
      this.navigateToRouteForNotification(notificationData.data);
    } else {
      const isModalOpen = await this.modalCtrl.getTop();
      if (isModalOpen)
        this.navigateToRouteForNotification(notificationData.data);
      else
        this.showNotificationMsgForeground(notificationData);
    }
  }

  async showNotificationMsgForeground(notification) {
    if (this.router.url.includes('/properties')) {
      this.reloadPendings.emit(true);
    }

    const toast = await this.toastCtlr.create({
      header: notification.title,
      message: notification.message,
      position: 'top',
      color: 'primary',
      duration: 6000,
      buttons: [{
        text: this.translate.instant('notifications.Ver'),
        handler: () => {
          this.navigateToRouteForNotification(notification.data);
        }
      }, {
        icon: 'close',
        role: 'cancel',
        handler: () => {
          this.utils.removeFromStorage('notification');
        }
      }]
    });
    toast.present();
  }

  async navigateToRouteForNotification(notification) {
    const action = notification.accion;
    // let total = await this.utils.getFromStorage('totalNotifications');
    // total = total > 0 ? total - 1 : 0;
    // this.utils.saveInStorage('totalNotifications', total);
    // await this.pushObject.setApplicationIconBadgeNumber(total);
    this.utils.saveInStorage('totalNotifications', 0);
    if (this.platform.is('android')) {
      await PushNotifications.removeAllDeliveredNotifications();
    }
    const isModalOpen = await this.modalCtrl.getTop();
    let route: string = '', toEmit, state;
    console.log('action', action)
    switch (action) {
      case 'confirmar':
        route = '/properties';
        toEmit = this.reloadPendings;
        state = {};
        break;
      case 'conformar':
        route = '/conformity';
        toEmit = this.reloadAC;
        state = {};
        break;
      case 'eliminar':
        route = '/requests';
        toEmit = this.reloadRequests;
        state = {};
        break;
      case 'chat':
        route = '/requirement-follow-up';
        toEmit = this.reloadMessages;
        state = { reqId: notification.solicitud_id, notification: true };
        break;
      default:
        route = '/requirement-follow-up';
        toEmit = this.reloadMessages;
        state = { reqId: notification.solicitud_id };
        break;
    }
    // this.utils.dismissLoading();
    if (this.router.url.includes(route)) {
      window.history.state.reqId = notification.solicitud_id;
      toEmit.emit();
    }
    else {
      if (isModalOpen) {
        await this.modalCtrl.dismiss();
        state = { reqId: notification.solicitud_id };
      }

      if (route === '/properties') {
        toEmit.emit();
      }
      this.router.navigate([route], { state });
    }
  }

  unsubscribeFromRegistration() {
    this.pushObjectSubscripcion.unsubscribe();
  }

}
